import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { App, ConfigProvider } from 'antd';
import antdLocalePtBR from 'antd/locale/pt_BR';
import ConfigEmotion from './ConfigEmotion';
import createThemeInternal from './createTheme';
import CustomCss from './css/custom';
import ResetCss from './css/reset';
const mediaDark = typeof window !== 'undefined' && (window === null || window === void 0 ? void 0 : window.matchMedia) ? window.matchMedia('(prefers-color-scheme: dark)') : null;
export const createTheme = createThemeInternal;
const defaultTheme = createTheme('eduzz');
function ThemeProvider(_a) {
    var { theme = defaultTheme, mode: modeProp = 'light', children, disableResetStyles } = _a, configProps = __rest(_a, ["theme", "mode", "children", "disableResetStyles"]);
    const [mode, setMode] = React.useState(() => {
        if (modeProp !== 'system') {
            return modeProp;
        }
        return (mediaDark === null || mediaDark === void 0 ? void 0 : mediaDark.matches) ? 'dark' : 'light';
    });
    const currentTheme = theme[mode];
    React.useEffect(() => {
        if (modeProp !== 'system')
            return setMode(modeProp !== null && modeProp !== void 0 ? modeProp : 'light');
        if (!mediaDark)
            return setMode('light');
        const listner = (event) => setMode(() => (event.matches ? 'dark' : 'light'));
        mediaDark.addEventListener('change', listner);
        return () => mediaDark.removeEventListener('change', listner);
    }, [modeProp]);
    React.useEffect(() => {
        const styleElement = document.createElement('link');
        styleElement.rel = 'stylesheet';
        styleElement.href = '//fonts.googleapis.com/css2?family=Albert+Sans:wght@300;400;500;600;700';
        document.head.appendChild(styleElement);
        return () => styleElement.remove();
    }, []);
    return (_jsx(ConfigProvider, Object.assign({ theme: currentTheme.antd, componentSize: 'large', locale: antdLocalePtBR }, configProps, { children: _jsx(App, { children: _jsxs(ConfigEmotion, Object.assign({ theme: currentTheme }, { children: [!disableResetStyles && _jsx(ResetCss, {}), _jsx(CustomCss, {}), children] })) }) })));
}
export default React.memo(ThemeProvider);
